<template>
  <div class="invoice-order">
    <fixed-header title="订单选择"></fixed-header>
    <div v-infinite-scroll="loadMore" :infinite-scroll-disabled="loading" :infinite-scroll-distance="30"
         class="invoice-order__main scroll-touch">
      <div class="invoice-order__main-wrap">
        <div v-for="(item, index) in orderList" :key="index" class="invoice-order__main-item">
          <div class="invoice-order__main-info">
            <span class="invoice-order__main-info-time">{{ item.orderSn }}</span>
            <span class="invoice-order__main-info-amount">￥{{ item.payMoney }}</span>
          </div>
          <div class="invoice-order__main-img">
            <div class="invoice-order__main-img-icon" @click="checkItem(item)">
              <i :class="['icon', checkList.indexOf(item.orderSn) !== -1 ? 'invoice_choose_on' : 'invoice_choose_off']"></i>
            </div>
            <div class="invoice-order__main-img-list scroll-touch">
              <invoice-img :goods-img-list="item.imgUrl"></invoice-img>
            </div>
          </div>
        </div>
      </div>
      <div class="invoice-order__main-button">
        <div class="invoice-order__main-button-icon" @click="checkAll">
          <i :class="['icon', isCheckAll ? 'invoice_choose_on' : 'invoice_choose_off']"></i>
        </div>
        <div class="invoice-order__main-button-info" @click="checkAll">
          <span class="invoice-order__main-button-info-item1">全选</span>
          <p class="invoice-order__main-button-info-item2">
            <span>{{ orderNum }}</span>个订单，共<span>{{ invoiceMoney }}</span>元</p>
        </div>
        <div class="invoice-order__main-button-item" @click="gotoInvoiceIssue">
          <span>下一步</span>
        </div>
      </div>

      <!--            <div v-if="showEmpty" class="invoice-order__empty">-->
      <!--                <i :class="['icon', 'invoice_empty']"></i>-->
      <!--                <p>暂无更多记录哦~</p>-->
      <!--            </div>-->
    </div>

  </div>
</template>

<script>
import FixedHeader from 'components/common/FixedHeader';
import InvoiceImg from 'components/invoice/img';
import * as Calculate from 'utils/calculate';
import * as invoiceApis from 'apis/invoice';
import { getMgtvUserTicket, setAsyncUserInfo } from 'utils/user';
import PageLoading from 'components/common/PageLoading';

export default {
  name: 'index',
  components: {
    FixedHeader, InvoiceImg, Calculate, PageLoading,
  },
  data() {
    return {
      p: 0,
      isCheckAll: false,
      orderNum: 0,
      invoiceMoney: 0,
      showEmpty: true,
      checkList: [],
      orderList: [],
      defaultTitle: {},
      loading: false, // false执行loadMore
      disableLoad: false,
    };
  },
  mounted() {
    this.initOrderCheckList();
    this.userDefaultTitle();
  },
  methods: {
    toast(message) {
      this.$toast({
        message,
        duration: 1000,
      });
    },
    /* 页面初始化会自动执行一次 */
    async loadMore() {
      if (this.disableLoad) {
        return;
      }
      if (this.loading) {
        return;
      }
      this.p += 1;
      const userInfo = getMgtvUserTicket();
      if (!(userInfo && userInfo.ticket)) {
        await setAsyncUserInfo();
      }
      this.orderListForInvoice();
      this.initShowEmpty();
    },
    async initShowEmpty() {
      if (this.orderList.length === 0) {
        this.showEmpty = true;
      } else {
        this.showEmpty = false;
      }
    },
    async initOrderCheckList() {
      console.log(`#####initOrderCheckList####\n${sessionStorage.getItem('invoiceOrderCheckInfo')}`);
      sessionStorage.removeItem('invoiceOrderCheckInfo');
    },
    async userDefaultTitle() {
      const userInvoiceTitle = sessionStorage.getItem('invoiceUserDefaultTitle');
      if (!userInvoiceTitle) {
        console.log('######初始化用户默认发票抬头#####');
        const data = await invoiceApis.userDefaultTitle();
        if (data) {
          this.defaultTitle = data;
          sessionStorage.setItem('invoiceUserDefaultTitle', JSON.stringify(this.defaultTitle));
        }
      }
    },
    async orderListForInvoice() {
      try {
        this.loading = true;
        const data = await invoiceApis.orderListForInvoice(this.p);
        if (data) {
          this.loading = false;
          this.orderList.push(...(data.list));
          this.changeCheckAllStatus();
          if (!(data.list).length) {
            this.disableLoad = true;
          }
        }
      } catch (error) {
        const { message } = error;
        this.$toast(`获取订单失败:${message}`);
      }
    },
    gotoInvoiceIssue() {
      if (this.invoiceMoney <= 0 || this.orderNum <= 0) {
        this.toast('请选择开票订单');
        return;
      }
      MgStat.send('click', {}, {
        mod: 'next',
        cont: '下一步',
        direct: 'cntp',
        label: 'btn',
        cntp: 'haowu_invoiceOrder',
      });
      const invoiceOrderCheckInfo = {
        orderSns: this.checkList.join(','),
        invoiceMoney: this.invoiceMoney,
      };
      sessionStorage.setItem('invoiceOrderCheckInfo', JSON.stringify(invoiceOrderCheckInfo));
      console.log(`#####gotoInvoiceIssue#####\n${sessionStorage.getItem('invoiceOrderCheckInfo')}`);
      this.$router.push({ path: '/invoice/issue' });
    },
    checkItem(item) {
      const itemIndex = this.checkList.indexOf(item.orderSn);
      if (itemIndex !== -1) {
        this.checkList.splice(itemIndex, 1);
        this.orderNum--;
        this.invoiceMoney = Calculate.NumberSub(this.invoiceMoney, item.payMoney);
      } else {
        this.checkList.push(item.orderSn);
        this.orderNum++;
        this.invoiceMoney = Calculate.NumberAdd(this.invoiceMoney, item.payMoney);
      }
      this.changeCheckAllStatus();
    },
    changeCheckAllStatus() {
      if (this.checkList.length !== this.orderList.length) {
        this.isCheckAll = false;
      } else {
        this.isCheckAll = true;
      }
    },
    checkAll() {
      if (this.orderList && this.orderList.length > 0) {
        let methodOrderNum = 0;
        let methodinvoiceMoney = 0;
        const methodCheckList = [];
        if (!this.isCheckAll) {
          this.orderList.forEach((item, index, arr) => {
            methodCheckList.push(item.orderSn);
            methodOrderNum++;
            methodinvoiceMoney = Calculate.NumberAdd(methodinvoiceMoney, item.payMoney);
          });
        }
        this.orderNum = methodOrderNum;
        this.invoiceMoney = methodinvoiceMoney;
        this.checkList = methodCheckList;
        this.isCheckAll = !this.isCheckAll;
      }
    },
  },

};
</script>

<style lang="scss">

.invoice-order {
  height: 100%;

  &__empty {
    margin-top: 210px;
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      margin-top: 12px;
      font-size: 28px;
      color: #a8a8a8;
    }
  }

  &__main {
    height: 100%;

    &-wrap {
      /*height: 80vh;*/
      padding-bottom: 180px;
    }

    &-item {
      margin-top: 20px;
      height: 220px;
      background: rgba(255, 255, 255, 1);
    }

    &-info {
      height: 62px;
      display: flex;
      flex-direction: row;
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.06);

      span {
        font-size: 26px;
        color: #0D0D0D;
      }

      &-time {
        margin-left: 84px;
        width: 541px;
      }

      &-amount {
        flex: 1;
        color: #FF5F00 !important;
        margin-right: 20px;
        text-align: right;
      }

    }

    &-img {
      margin: 27px 20px 27px 0;
      display: flex;
      flex-direction: row;

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 84px;
      }

      &-list {
        flex: 1;
      }

    }

    &-button {
      width: 100%;
      height: 160px;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 1);
      display: flex;
      flex-direction: row;
      align-items: center;

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 84px;
      }

      &-info {
        width: 442px;
        display: flex;
        flex-direction: column;

        &-item1 {
          font-size: 30px;
          color: #0D0D0D;
        }

        &-item2 {
          font-size: 24px;
          color: #9A9A9A;

          span {
            color: #FF5F00 !important;
          }
        }
      }

      &-item {
        flex: 1;
        height: 80px;
        margin-right: 24px;
        background-image: linear-gradient(90deg, #fa841b 17%, #ff6002 85%);
        border-radius: 40px;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          font-size: 28px;
          color: #FFFFFF;
        }
      }
    }

  }


}

</style>
